export default __webpack_public_path__ + "static/media/dog2.a067dc4d.JPG";